import { PriceBreakUpItem } from '@/src/types/fareFamilyInfo'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { Box, Divider, Typography } from '@mui/material'

const TimelinePriceBreakup = ({
    priceBreakup,
    formatCurrency
}: {
    priceBreakup: PriceBreakUpItem[]
    formatCurrency: (value: number) => string
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {priceBreakup.map((field, index) => {
                const { deducted, title, value, code: tuppleCode } = field
                return tuppleCode === 'LINE_SEPARATOR' ? (
                    <Divider key={index} sx={{ borderColor: 'neutral.white' }} />
                ) : (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 2
                        }}
                    >
                        <Typography sx={{ fontSize: '14px', color: 'neutral.white', fontWeight: 400 }}>
                            {title}
                        </Typography>
                        {!isEmpty(value) && (
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    color: 'neutral.white',
                                    fontWeight: 500,
                                    textAlign: 'right'
                                }}
                            >
                                {formatCurrency(deducted && value !== 0 ? -value : value)}
                            </Typography>
                        )}
                    </Box>
                )
            })}
        </Box>
    )
}

export default TimelinePriceBreakup
